import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, maxWidth, Text, units } from '@calm-web/design-system';

import CtaWithButton from '@/components/ui/CtaWithButton';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	background: ${palette('white')};
	width: 560px;
	padding: ${units(3)} ${units(3)};
	border-radius: 16px;
	margin-bottom: ${units(6)};

	${maxWidth('tablet')} {
		width: 100%;
	}
`;
export const PricingContainer = styled.div`
	display: flex;
	align-items: center;
	color: ${palette('text')};
	width: 100%;
`;

export const LoadingWrapper = styled.div`
	margin-bottom: ${units(4.5)};
`;

export const PricePerUserColumn = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	margin-bottom: ${units(4)};
	position: relative;
`;

export const StyledBorder = styled.div`
	position: absolute;
	left: 0;
	top: auto;
	bottom: 0;
	width: 1px;
	background-color: ${palette('gray1')};
	height: 98px;
`;

export const StyledHeaderText = styled(Text)`
	${fontWeight(FontWeights.Medium)};
	${fontSize(FontSizes.base)}

	${maxWidth('mobileLarge')} {
		font-size: 20px;
	}
`;

export const PricingText = styled(Text).attrs({
	size: FontSizes['3xl'],
})`
	${maxWidth('mobileLarge')} {
		font-size: 45px;
	}
`;

export const StyledText = styled(Text)`
	${fontWeight(FontWeights.Medium)};
	line-height: ${units(3)};
	margin-bottom: ${units(0.5)};

	${maxWidth('mobileLarge')} {
		font-size: 20px;
		line-height: ${units(4)};
	}
`;

export const StyledHr = styled.hr`
	width: 100%;
	margin: ${units(3, 0)};
	color: ${palette('gray1')};
	opacity: 0.2;
`;

export const StyledFormInputContainer = styled.div`
	display: flex;
	width: 131px;
	flex-direction: column;
	align-items: flex-start;
	margin: ${units(2)} 0;

	${maxWidth('mobileLarge')} {
		width: 171px;
	}
`;

export const StyledCtaWithButton = styled(CtaWithButton)`
	margin: ${units(2)} 0;
`;
